import Axios from 'axios';

class api {

  instanciaAxios = null;

  constructor () {
    this.instanciaAxios = Axios.create ({
      baseURL: process.env.VUE_APP_URL_BASE_BACKEND,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  // control de sesion
  establecerAccessToken (access_token) {
    this.instanciaAxios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
  }

  eliminarAccessToken () {
    delete this.instanciaAxios.defaults.headers.common['Authorization']
  }

  iniciarSesion (email, password) {
    let peticion = {
      correoElectronico: email,
      contrasena: password
    };
    return this.instanciaAxios.post('/sesion/iniciar', peticion)
  }

  cerrarSesion () {
    return this.instanciaAxios.post('/sesion/cerrar')
  }

  obtenerDatosSesion () {
    return this.instanciaAxios.get('/sesion/datos')
  }

  guardarDatosSesion (datos) {
    return this.instanciaAxios.post (`/sesion/datos`, datos)
  }

  recuperarContrasena (email) {
    let peticion = {
      correoElectronico: email
    }
    return this.instanciaAxios.post('/recuperar_contrasena', peticion)
  }

  restablecerContrasena (tokenSeguridad, nuevaContrasena) {
    let peticion = {
      tokenSeguridad: tokenSeguridad,
      nuevaContrasena: nuevaContrasena
    };
    return this.instanciaAxios.post ('/restablecer_contrasena', peticion)
  }

  guardarPreferenciasOperador (preferencias) {
    return this.instanciaAxios.post('/preferencias_operador', preferencias)
  }

  //------------------------

  // sistema
  obtenerParametrosConfiguracion () {
    return this.instanciaAxios.get ("/parametros_configuracion")
  }
  obtenerTablasConsulta (parametros) {
    return this.instanciaAxios.get ('/tablas_consulta', { params: parametros })
  }
  obtenerInformacionEstadoSistema () {
    return this.instanciaAxios.get ("/informacion_estado_sistema")
  }
  ejecutarSQL (datos) {
    return this.instanciaAxios.post ("/ejecutar_sql", datos)
  }

  // CRUD
  obtenerRegistrosTablaVista (modeloDatos, parametros, controlErrores = true) {
    return this.instanciaAxios.get (`/base_datos/${modeloDatos}`, { params: parametros, _opciones: { controlErrores: controlErrores } })
  }
  anadirRegistroTablaVista (modeloDatos, registro, controlErrores = true) {
    return this.instanciaAxios.post (`/base_datos/${modeloDatos}`, registro, { _opciones: { controlErrores: controlErrores } })
  }
  modificarRegistroTablaVista (modeloDatos, registro, claveRegistro, controlErrores = true) {
    return this.instanciaAxios.put (`/base_datos/${modeloDatos}`, registro, { params: claveRegistro, _opciones: { controlErrores: controlErrores } })
  }
  eliminarRegistroTablaVista (modeloDatos, claveRegistro, controlErrores = true) {
    return this.instanciaAxios.delete (`/base_datos/${modeloDatos}`, { params: claveRegistro, _opciones: { controlErrores: controlErrores } })
  }
  loteCambiosRegistrosTablaVista (modeloDatos, registros, claveRegistro, controlErrores = true) {
    if (registros.insertar.length > 0 || registros.actualizar.length > 0 || registros.eliminar.length > 0)
      return this.instanciaAxios.patch (`/base_datos/${modeloDatos}`, registros, { params: claveRegistro, _opciones: { controlErrores: controlErrores } })
  }

  // general
  activarCargador (datos) {
    return this.instanciaAxios.post ("/activar_cargador", datos)
  }
  desactivarCargador (datos) {
    return this.instanciaAxios.post ("/desactivar_cargador", datos)
  }

}

export default new api();